import { useSidebarStore } from '@ice-web-app/shared-store';
import { SidebarMenuItem } from '@ice-web-app/shared-types';
import { FC, SetStateAction } from 'react';
import { DsIcon } from '../../../../components/icons/DsIcon';
import { MenuItem, SubMenu } from '../../../@menu/vertical-menu';

interface Props {
  menu: SidebarMenuItem;
  menuIndex: number;
  addSidebarMode: boolean;
  selectedSidebar: SidebarMenuItem[];
  toggleSelectSidebar: (menu: SidebarMenuItem) => void;
  setSelectedSidebar: (value: SetStateAction<SidebarMenuItem[]>) => void;
}
const VerticalMenuSubItems: FC<Props> = ({
  menu,
  addSidebarMode,
  menuIndex,
  selectedSidebar,
  toggleSelectSidebar,
  setSelectedSidebar,
}) => {
  const { menuMySidebarItems = [] } = useSidebarStore();
  return (
    <SubMenu
      href={menu.path}
      label={menu.title}
      icon={menu.icon}
      key={menuIndex}
      badge={menu.badge}
      permissions={menu.permissions}
      disabled={menu.disabled}
      addSidebarMode={addSidebarMode}
      {...(addSidebarMode && {
        suffix: (
          <DsIcon
            icon={
              selectedSidebar.find((menuItem) => menuItem.path === menu.path)
                ? localStorage.getItem('MY_SIDEBAR') === 'true'
                  ? 'MINUS_IN_FRAME'
                  : 'PLUS_IN_FRAME_FILL'
                : localStorage.getItem('MY_SIDEBAR') === 'true'
                  ? 'MINUS_FILL'
                  : 'PLUS_IN_FRAME'
            }
            color={localStorage.getItem('MY_SIDEBAR') === 'true' ? 'error.500' : 'primary.500'}
          />
        ),
        suffixOnClick: () => {
          if (selectedSidebar.find((menuItem) => menuItem.path === menu.path)) {
            toggleSelectSidebar({ ...menu, submenu: [] });
          } else {
            const subMenuItems = [...(menu.submenu || [])].filter(
              (subItem) => !!selectedSidebar.find((menuItem) => menuItem.path === subItem.path),
            );
            const cleanSubMenuItems = selectedSidebar.filter(
              (menuItem) => !subMenuItems.find((subMenu) => subMenu.path === menuItem.path),
            );
            setSelectedSidebar([...cleanSubMenuItems, { ...menu, submenu: subMenuItems }]);
          }
        },
      })}
    >
      {menu.submenu?.map(
        (sub, subIndex) =>
          (localStorage.getItem('MY_SIDEBAR') !== 'true' ||
            menuMySidebarItems
              ?.find((menuItem) => menuItem.path === menu.path)
              ?.submenu?.find((subItem) => subItem.path === sub.path)) && (
            <MenuItem
              href={sub.path}
              key={subIndex}
              badge={sub.badge}
              permissions={sub.permissions}
              disabled={sub.disabled}
              {...(addSidebarMode && {
                suffix: (
                  <DsIcon
                    icon={
                      selectedSidebar?.find((menuItem) => menuItem.path === sub.path) ||
                      selectedSidebar
                        ?.find((menuItem) => menuItem.path === menu.path)
                        ?.submenu?.find((subItem) => subItem.path === sub.path)
                        ? localStorage.getItem('MY_SIDEBAR') === 'true'
                          ? 'MINUS_IN_FRAME'
                          : 'PLUS_IN_FRAME_FILL'
                        : localStorage.getItem('MY_SIDEBAR') === 'true'
                          ? 'MINUS_FILL'
                          : 'PLUS_IN_FRAME'
                    }
                    color={localStorage.getItem('MY_SIDEBAR') === 'true' ? 'error.500' : 'primary.500'}
                  />
                ),
                suffixOnClick: () => {
                  const parentMenuIndex = selectedSidebar.findIndex((menuItem) => menuItem.path === menu.path);
                  if (parentMenuIndex >= 0) {
                    if (selectedSidebar[parentMenuIndex].submenu?.find((menuItem) => menuItem.path === sub.path)) {
                      setSelectedSidebar((preState) => {
                        const newState = [...preState];
                        const parentMenu = { ...newState[parentMenuIndex] };
                        parentMenu.submenu = parentMenu.submenu?.filter((sb) => sb.path !== sub.path);
                        newState[parentMenuIndex] = parentMenu;
                        return newState;
                      });
                    } else {
                      setSelectedSidebar((preState) => {
                        const newState = [...preState];
                        const parentMenuIndex = newState.findIndex((menuItem) => menuItem.path === menu.path);
                        if (parentMenuIndex >= 0) {
                          const existingSubmenu = newState[parentMenuIndex].submenu || [];
                          const isSubExist = existingSubmenu.some((sb) => sb.path === sub.path);
                          if (!isSubExist) {
                            newState[parentMenuIndex].submenu = [...existingSubmenu, sub];
                          }
                        }
                        return newState;
                      });
                    }
                  } else {
                    toggleSelectSidebar(sub);
                  }
                },
              })}
            >
              {sub.title}
            </MenuItem>
          ),
      )}
    </SubMenu>
  );
};
export default VerticalMenuSubItems;
